export default __webpack_public_path__ + "static/media/Segoe-ui-historic.73e9cd89.ttf";